import { useContext } from 'react';
import { ModuleContext } from '../context/ModuleContext';

export const useModule = () => {
    return useContext(ModuleContext);
};
